import Base from '../Base';
import Component from 'vue-class-component';
import { Button } from 'streamlabs-beaker';
import UserApi from '@/apis/user-api';
import { EUserFlag } from '@/helpers/user';

@Component({
  components: {
    SButton: Button,
  },
})
export default class ConnectPlatform extends Base {
  get platforms(): any[] {
    return [
      {
        name: 'Twitch',
        icon: 'icon-twitch',
        required: true,
        connected: this.hasTwitch,
      },
      {
        name: 'YouTube',
        icon: 'icon-youtube',
        required: false,
        connected: this.userHasYouTube,
      },
      {
        name: 'Kick',
        icon: 'icon-kick',
        required: false,
        connected: this.userHasKick,
      },
      {
        name: 'Tiktok',
        icon: 'icon-tiktok',
        required: false,
        connected: this.userHasTiktok,
      },
    ].filter((platform) => {
      return this.availablePlatforms.includes(platform.name.toLowerCase());
    });
  }

  get allPlatformConnected(): boolean {
    return this.platforms.every((account) => account.connected);
  }

  get skipButtonText(): string {
    return !this.allPlatformConnected ? 'Skip For Now' : 'Next';
  }

  onLoginButtonClick(platform) {
    window.open(`/auth/${platform.name.toLowerCase()}?intent=link`, '_blank');
  }

  async nextStep() {
    await this.removeUserFlag(EUserFlag.showOnboarding);
    UserApi.removeShowOnboardingFlag();

    if (!this.userSubscriptionIsValid) {
      this.$router.push('/checkout');
      return;
    }

    this.$router.push('/projects');
  }

  mounted() {
    window.addEventListener('message', this.onMessage);
  }

  beforeClose() {
    window.removeEventListener('message', this.onMessage);
  }

  async onMessage(message) {
    if (message.data && message.data.type === 'callback-success' && message.origin === window.origin) {
      this.loadUser(true);
    }
  }
}
